import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const comboboxOptionFn = /* @__PURE__ */ createRecipe('combobox-option', {
  "colors": "neutral"
}, [])

const comboboxOptionVariantMap = {
  "type": [
    "create"
  ],
  "color": [
    "danger"
  ]
}

const comboboxOptionVariantKeys = Object.keys(comboboxOptionVariantMap)

export const comboboxOption = /* @__PURE__ */ Object.assign(memo(comboboxOptionFn.recipeFn), {
  __recipe__: true,
  __name__: 'comboboxOption',
  __getCompoundVariantCss__: comboboxOptionFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: comboboxOptionVariantKeys,
  variantMap: comboboxOptionVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, comboboxOptionVariantKeys)
  },
  getVariantProps: comboboxOptionFn.getVariantProps,
})